export class HeroBg extends DrupalBehavior {
  onReady() {
    const breakpoint = window.matchMedia('(min-width: 768px)');

    breakpoint.addEventListener('change', this.build());
    addEventListener('resize', (event) => {
      this.build();
    });
  }

  // Centered full screen width video header.
  build() {
    let $videoContainer = document.getElementsByClassName('hero__bg-video')[0];
    if ($videoContainer) {
      let marginTop = 0;
      let $videoIframe = $videoContainer.getElementsByTagName('iframe');
      if ($videoIframe && $videoIframe.length) {
        let $hero = document.getElementsByClassName('hero__bg')[0];

        marginTop -= $videoIframe[0].offsetHeight / 2 - $hero.offsetHeight / 2;
        $videoIframe[0].style.top = marginTop + 'px';
      }
    }
  }
}

DrupalBehavior.register('rush_theme.components', 'hero_bg', HeroBg);
